import { SxProps, Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';

export const perksSectionStyles: SxProps<Theme> = {
	display: 'flex',
	flexFlow: { xs: 'column', md: 'row wrap' },
	alignItems: { xs: 'center', md: 'flex-start' },
	gap: '24px',
	position: 'relative',
	pt: { xs: '16px', sm: '24px', md: '34px' },
	px: { xs: '16px', sm: 0 },
	borderBottomLeftRadius: '8px',
	borderBottomRightRadius: '8px',
};

export const perksPlaceholderBoxStyles: SxProps<Theme> = {
	position: 'absolute',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	background: 'linear-gradient(90deg, rgba(0, 0, 0, 0.00) 0%, #000 100%)',
	borderRadius: '8px',
	backdropFilter: 'blur(28px)',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'flex-start',
	pt: 3,
};

export const perksPlaceholderContentStyles: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: '20px',
	textAlign: 'center',
	maxWidth: '505px',
};

export const perksPlaceholderTitleStyles: SxProps<Theme> = {
	color: 'white',
	fontFamily: 'Montserrat',
	fontSize: '17px',
	fontWeight: 700,
	lineHeight: '1em',
};

export const perksPlaceholderDescriptionStyles: SxProps<Theme> = {
	color: 'white',
	fontFamily: 'Montserrat',
	fontSize: '14px',
	fontWeight: 500,
	lineHeight: '18px',
};

export const perksPlaceholderButtonStyles: SxProps<Theme> = {
	fontFamily: 'Montserrat',
	fontSize: '14px',
	fontWeight: 600,
	lineHeight: '17px',
	textTransform: 'none',
	backgroundColor: 'white',
	color: 'black',
	borderRadius: '100px',
	p: '10px 24px',

	'&:hover': {
		backgroundColor: Colors.white_a5,
		color: 'white',
	},
};
